// ヘッダーメニューの現在ページにカレント表示を付与
// 上位 .label にのみ -current を付ける（メガメニュー内サブカードは対象外）
// WordPress 移行後は PHP 側で同等のクラスを付与する想定
export const initHeaderNavCurrent = () => {
  const currentPath = window.location.pathname.replace(/\/$/, '');
  const items = document.querySelectorAll('.header-menu .nav > .item');

  items.forEach(item => {
    const label = item.querySelector('.label');
    if (!label) return;

    // 上位リンクの URL を取得
    // <a class="label"> ならその href
    // <button class="label"> ならメガメニュー内 .info > .link の href
    let href = label.getAttribute('href');
    if (!href) {
      const infoLink = item.querySelector('.dropdown .info .link');
      href = infoLink?.getAttribute('href');
    }
    if (!href) return;

    const linkPath = new URL(href, window.location.origin).pathname.replace(/\/$/, '');

    // ルート('/')は完全一致のみ。それ以外はプレフィックス一致
    const isCurrent = linkPath === ''
      ? currentPath === ''
      : currentPath === linkPath || currentPath.startsWith(linkPath + '/');

    if (isCurrent) {
      label.classList.add('-current');
    }
  });
};
